<template>
  <div>
    <b-card class="col-12" no-body>
      <div class="m-2">
        <b-row>
          <b-col cols="12">
            <h4>
              Danh sách đơn hàng
              <a v-b-tooltip.hover.top="'Lấy lại danh sách!'" class="btn-icon" @click="$router.go()">
                <feather-icon
                    icon="RepeatIcon"/>
              </a>
            </h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="deliverd" cols="10">
            <b-tabs>
              <b-tab v-for="f in flow" :key="f.ID" :active="selectedTab == f.ID" :title="f.Name" @click="changeTab(f)">
              </b-tab>
            </b-tabs>
          </b-col>
          <b-col class="text-end mb-2" cols="2">
            <vue-excel-xlsx :columns="fields.filter((el) => el.label != 'Action')" :data="exportExcelData"
                            :file-name="'Thống kê đơn hàng'" :file-type="'xlsx'" :sheet-name="'sheetname'"
                            class="border-0 bg-transparent">
              <b-button class="btn" variant="primary"> Export</b-button>
            </vue-excel-xlsx>
          </b-col>
        </b-row>

        <!-- <b-row class="mt-1 mb-1">
          <b-col cols="6" class="text-center">
            <b-form-group>
              <b-button variant="primary" @click="onSelectOrderTime(0)"
                :class="'btn ' + (selectedOrderTime == 0 ? '' : 'unselected')">
                Today
              </b-button>
            </b-form-group>
          </b-col>
          <b-col cols="6" class="text-center">
            <b-form-group>
              <b-button variant="primary" @click="onSelectOrderTime(1)"
                :class="'btn ' + (selectedOrderTime == 1 ? '' : 'unselected')">
                Tùy chọn
              </b-button>
            </b-form-group>
          </b-col>
        </b-row> -->
        <!-- <b-row class="mt-1 mb-1">
          <b-col cols="4">
            <div>Tồn đầu:............</div>
          </b-col>
          <b-col cols="4">
            <div>Kết nối thành công:..........</div>
          </b-col>
          <b-col cols="4">
            <div>Tồn cuối:...............</div>
          </b-col>
        </b-row> -->
        <!-- <b-row v-if="selectedOrderTime == 1" class="mb-1">
          <b-col cols="12" md="4">
            <validation-provider name="Trạng thái" #default="{ errors }" :rules="''">
              <b-form-group label="Trạng thái">
                <Select2 :options="statusList" :state="errors.length > 0 ? false:null"
                  v-model="serverParams.columnFilters.STATUS" />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" md="4">
            <validation-provider name="Từ ngày" #default="{ errors }" :rules="''">
              <b-form-group label="Từ ngày">
                <b-input-group label="Từ ngày">
                  <b-form-datepicker :state="errors.length > 0 ? false:null"
                    :date-format-options="{  year: 'numeric', month: 'numeric', day: 'numeric',}" today-button
                    reset-button close-button locale="vi-VN" v-model="serverParams.columnFilters.FROM" />
                </b-input-group>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" md="4">
            <validation-provider name="Đến ngày" #default="{ errors }" :rules="''">
              <b-form-group label="Đến ngày">
                <b-input-group label="Đến ngày">
                  <b-form-datepicker :state="errors.length > 0 ? false:null"
                    :date-format-options="{  year: 'numeric', month: 'numeric', day: 'numeric',}" today-button
                    reset-button close-button locale="vi-VN" v-model="serverParams.columnFilters.TO" />
                </b-input-group>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row> -->
        <b-row>
          <b-col cols="12">
            <vue-good-table :columns="fields" :isLoading.sync="isLoading" :line-numbers="true" :pagination-options="{
                  perPage: serverParams.pageSize,
                  enabled: true,
                  dropdownAllowAll: true,
                  allLabel: 'All',
                  setCurrentPage: serverParams.page,
                }"
                            :rows="tableData" :totalRows="totalRecords"
                            mode="remote"
                            @on-page-change="onPageChange" @on-sort-change="onSortChange" @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange">
              <!-- <template slot="table-column" slot-scope="props">
                <span v-if="props.column.field =='username'">
                  {{props.column.label}}
                </span>
                <span v-else>
                 {{props.column.label}}
                </span>
              </template> -->
              <template slot="table-row" slot-scope="props">
                <!-- Column: Action -->
                <span v-if="props.column.field === 'action'">
                  <span class="action-col">
                    <b-button class="btn-icon" size="sm" variant="primary" @click="onShowDetailModal(props.row)">
                      <feather-icon icon="EyeIcon"/>
                    </b-button>
                  </span>
                </span>
                <span v-else-if="props.column.field === 'CreateDate' ||
                  props.column.field === 'activatedDate' ||
                  props.column.field === 'CallDate'
                  ">
                  {{ getDateTime(props.formattedRow[props.column.field]) }}
                </span>
                <span v-else-if="props.column.field === 'Status'">
                  {{
                    status.find(
                      (item) =>
                        item.id == props.formattedRow[props.column.field]
                    ).text
                  }}
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-modal id="activated-order-modal" :title="`Cuộc gọi tới số thuê bao ${selectedRecord ? selectedRecord.ContactNumber : ''
      } - ${selectedRecord ? selectedRecord.RefID : ''}`" body-class="modal-activated-order" hide-footer size="xl">
      <b-button v-if="flowId!==11" style="
          position: absolute;
          right: 4rem;
          top: 0;
          padding: 5px 5px;
          z-index: 1;
        " variant="danger" @click="openTabCreateSimOrder">Tạo đơn sim
      </b-button>
      <validation-observer ref="modalView">
        <b-row>
          <b-col class="col-700-scroll" cols="4">
            <h5>Thông tin chung</h5>
            <b-card body-class="p-1" class="mb-1">
              <b-card-text>
                <b-row>
                  <b-col v-for="(item, index) in detailColumnExtra" :key="index" cols="12">
                    <b-form-group :label="item.label">
                      <b-form-input :value="detailQuestionExtra.Detail
                          ? detailQuestionExtra.Detail[item.key]
                          : ''
                        " disabled size="sm"/>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-card>
            <b-card v-for="(table, index) in detailQuestionExtra.ExtraDataTable" :key="index" body-class="p-0"
                    class="mb-1">
              <b-card-text>
                <div class="history-call__header">
                  <h5>{{ table.TableName }}</h5>
                  <h5>{{ table.TableData.length }}</h5>
                </div>
                <b-table :bordered="false" :borderless="false" :dark="false" :fields="table.TableColumn.map((item) => ({
                      key: Object.keys(item)[0],
                      label: item[Object.keys(item)[0]],
                    }))
                    " :fixed="false"
                         :hover="false" :items="table.TableData" :no-border-collapse="false" :outlined="false" :small="false" :striped="false"></b-table>
              </b-card-text>
            </b-card>
          </b-col>
          <b-col class="col-700-scroll" cols="8">
            <h5>Thông tin khảo sát</h5>
            <b-card v-if="listOfConnection.length > 0" body-class="p-1" class="mb-1">
              <b-card-text>
                <b-row>
                  <b-col cols="6">
                    <h5>Trạng thái kết nối</h5>
                    <template v-for="(s, i) in listOfConnection">
                      <b-form-group :key="i" :label="`Kết nối lần ${i + 1}`">
                        <b-form-radio-group v-model="s.callStatusSelected" :disabled="disabledModalField" :options="s.callStatus"
                                            text-field="text" value-field="id"
                                            @change="onCallStatusSelectedConnection(s)"></b-form-radio-group>
                      </b-form-group>
                    </template>

                  </b-col>
                  <b-col cols="6">
                    <b-form-group label="Ghi chú">
                      <b-form-textarea v-model="detailQuestionExtra.Note" :disabled="disabledModalField" rows="1"
                                       size="sm"></b-form-textarea>
                    </b-form-group>
                  </b-col>
                </b-row>
                <div v-if="flowId===11">
                  <h5>Số điện thoại liên hệ</h5>
                  <b-form-input v-model="contactPhone" class="col-4"></b-form-input>
                </div>
              </b-card-text>
            </b-card>
            <template v-if="callStatusSelected == 1">
              <b-card v-for="(question, index) in detailQuestions" :key="index" body-class="p-1" class="mb-1">
                <b-card-text>
                  <b-row>
                    <b-col cols="12">
                      <validation-provider #default="{ errors }" :rules="question.required ? 'required' : ''">
                        <b-form-group>
                          <!-- <b-row v-if="question.type == 'T'">
                            <b-col cols="4">
                              <div class="note-question">
                                <small>Mã đơn hàng</small>
                              </div>
                              <b-form-input
                                size="sm"
                                v-model="question.orderCode"
                                :disabled="disabledModalField"
                              />
                            </b-col>
                          </b-row> -->
                          <p v-html="question.text"></p>
                          <div v-if="question.note" class="note-question">
                            <small v-html="question.note"></small>
                          </div>
                          <b-form-radio-group v-if="question.type == 'R'" v-model="question.value" :disabled="disabledModalField"
                                              :options="question.options" disabled-field="notEnabled" text-field="text"
                                              value-field="id"></b-form-radio-group>
                          <b-form-input v-else-if="question.type == 'T'" v-model="question.value" :disabled="disabledModalField"
                                        size="sm"/>
                          <b-form-input v-else-if="question.type == 'N'" v-model="question.value" :disabled="disabledModalField" number
                                        size="sm" type="number"/>
                          <b-form-checkbox-group v-else-if="question.type == 'C'" v-model="question.value"
                                                 :disabled="disabledModalField" :options="question.options" disabled-field="notEnabled"
                                                 text-field="text"
                                                 value-field="id"></b-form-checkbox-group>
                          <b-form-select v-else-if="question.type == 'S'" v-model="question.value"
                                         :disabled="disabledModalField" :options="question.options"></b-form-select>
                          <div class="error-txt">
                            <small v-if="errors.length > 0">Bạn không được để trống trường này</small>
                          </div>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col v-if="question.type == 'R' && question.value == 1" cols="12">
                      <b-form-textarea v-model="question.subValue" :disabled="disabledModalField" rows="1"
                                       size="sm"></b-form-textarea>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-card>
            </template>
            <template v-if="callStatusSelected == 0">
              <b-card body-class="p-1" class="mb-1">
                <b-card-text>
                  <b-row>
                    <b-col cols="12">
                      <b-form-group label="Thời gian hẹn gọi lại">
                        <flat-pickr v-model="appointmentTime" :config="{
                            enableTime: true,
                            dateFormat: 'd-m-Y H:i',
                          }" :disabled="disabledModalField" class="form-control"/>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-card>
            </template>
            <div class="d-flex justify-content-end mb-2">
              <button class="btn btn-primary" type="button" @click="handleOk">
                OK
              </button>
            </div>
          </b-col>
        </b-row>
      </validation-observer>
    </b-modal>
    <b-modal id="update-info-order-modal" :title="`Cuộc gọi tới số thuê bao ${selectedRecord ? selectedRecord.ContactNumber : ''
      } - ${selectedRecord ? selectedRecord.RefID : ''}`" body-class="modal-activated-order" hide-footer size="xl"
             @hide="handleHide">
      <b-button style="
          position: absolute;
          right: 4rem;
          top: 0;
          padding: 5px 5px;
          z-index: 1;" variant="danger" @click="openTabCreateSimOrder">Tạo đơn sim
      </b-button>
      <validation-observer ref="modalView">
        <b-row>
          <b-col class="col-700-scroll" cols="4">
            <b-row>
              <b-col cols="12">
                <h4>Thông tin khách hàng</h4>
                <b-card body-class="p-1">
                  <b-card-text>
                    <b-row>
                      <b-col cols="12">
                        <b-form-group label="Tên khách hàng">
                          <b-form-input v-model="currentItem.FullName" disabled size="sm"/>
                        </b-form-group>
                      </b-col>
                      <b-col cols="5">
                        <b-form-group label="Số liên hệ">
                          <b-form-input v-model="currentItem.ContactNumber" :disabled="!isEditPhoneEmail" size="sm"/>
                        </b-form-group>
                      </b-col>
                      <b-col class="pl-0" cols="7">
                        <b-form-group label="Email">
                          <b-form-input v-model="currentItem.Email" :disabled="!isEditPhoneEmail" size="sm"/>
                        </b-form-group>
                      </b-col>
                      <!-- <b-col cols="12" :class="[{'mb-3': !currentItem.DeliveryType==1 || !currentItem.City},'text-right']"><b-button variant="primary" @click="updatePhoneAndMail" size="sm">{{ isEditPhoneEmail ? 'Lưu' : 'Sửa' }}</b-button></b-col> -->
                      <b-col v-if="currentItem.DeliveryType == 1" cols="12">
                        <b-row>
                          <b-col cols="12">
                            <b-form-group label="Tỉnh/Thành phố">
                              <search-select v-model="currentItem.CityId" :disabled="!isEditPhoneEmail"
                                             :options="Cities"
                                             @change="fetchDistricts(true)"></search-select>
                            </b-form-group>
                          </b-col>
                          <b-col cols="12">
                            <b-form-group label="Quận/Huyện">
                              <search-select v-model="currentItem.DistrictId" :disabled="!isEditPhoneEmail"
                                             :options="Districts" @change="fetchWards(true)"></search-select>
                            </b-form-group>
                          </b-col>
                          <b-col cols="12">
                            <b-form-group label="Phường/Xã/Thị trấn">
                              <search-select v-model="currentItem.WardId" :disabled="!isEditPhoneEmail"
                                             :options="Wards"></search-select>
                            </b-form-group>
                          </b-col>
                          <b-col cols="12">
                            <b-form-group label="ẤP/Khu/Tòa">
                              <search-select v-model="currentItem.HamletId" :disabled="!isEditPhoneEmail"
                                             :options="hamlets"></search-select>
                            </b-form-group>
                          </b-col>
                          <b-col cols="12">
                            <b-form-group label="Địa chỉ">
                              <b-form-input v-model="currentItem.Addr" :disabled="!isEditPhoneEmail" size="sm"/>
                            </b-form-group>
                          </b-col>

                        </b-row>
                      </b-col>
                      <b-col v-if="currentItem.DeliveryType == 1" class="text-right d-flex justify-content-end col-gap-1"
                             cols="12">
                        <b-button size="sm" variant="primary" @click="updatePhoneAndMail">{{ isEditPhoneEmail ? "Lưu" :
                          "Sửa"
                          }}
                        </b-button>

                        <b-button size="sm" variant="primary" @click="cancelOrder">Hủy đơn</b-button>
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-card>

                <b-card v-for="(table, index) in detailQuestionExtra.ExtraDataTable" :key="index" body-class="p-0"
                        class="mb-1">
                  <b-card-text>
                    <div class="history-call__header">
                      <h5>{{ table.TableName }}</h5>
                      <h5>{{ table.TableData.length }}</h5>
                    </div>
                    <b-table :bordered="false" :borderless="false" :dark="false" :fields="table.TableColumn.map((item) => ({
                          key: Object.keys(item)[0],
                          label: item[Object.keys(item)[0]],
                        }))
                        " :fixed="false"
                             :hover="false" :items="table.TableData" :no-border-collapse="false" :outlined="false" :small="false" :striped="false"></b-table>
                  </b-card-text>
                </b-card>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <h5>Logs</h5>
                <b-card v-if="currentItem.logs" body-class="p-0" class="p-0">
                  <b-card-text style="overflow: auto">
                    <table class="table table-bordered table-sm">
                      <tr>
                        <th>Loại</th>
                        <th>Logs</th>
                        <th>Ngày</th>
                      </tr>
                      <tr v-for="i in currentItem.logs" :key="i.Id">
                        <td>{{ i.LogType }}</td>
                        <td>{{ i.Content }}</td>
                        <td>{{ i.date_ }}</td>
                      </tr>
                    </table>
                  </b-card-text>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
          <b-col class="col-700-scroll" cols="8">
            <h5>Thông tin khảo sát</h5>
            <b-card v-if="listOfConnection.length > 0" body-class="p-1" class="mb-1">
              <b-card-text>
                <b-row>
                  <b-col cols="6">
                    <h5>Trạng thái kết nối</h5>
                    <template v-for="(s, i) in listOfConnection">
                      <b-form-group :key="i" :label="`Kết nối lần ${i + 1}`">
                        <b-form-radio-group v-model="s.callStatusSelected" :disabled="disabledModalField" :options="s.callStatus"
                                            text-field="text" value-field="id"
                                            @change="onCallStatusSelectedConnection(s)"></b-form-radio-group>
                      </b-form-group>
                    </template>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group label="Ghi chú">
                      <b-form-textarea v-model="detailQuestionExtra.Note" :disabled="disabledModalField" rows="1"
                                       size="sm"></b-form-textarea>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-card>
            <template v-if="callStatusSelected == 1">
              <b-card v-for="(question, index) in detailQuestions" :key="index" body-class="p-1" class="mb-1">
                <b-card-text>
                  <b-row>
                    <b-col cols="12">
                      <validation-provider #default="{ errors }" :rules="question.required ? 'required' : ''">
                        <b-form-group :label="question.text">
                          <!-- <b-row v-if="question.type == 'T'">
                            <b-col cols="4">
                              <div class="note-question">
                                <small>Mã đơn hàng</small>
                              </div>
                              <b-form-input
                                size="sm"
                                v-model="question.orderCode"
                                :disabled="disabledModalField"
                              />
                            </b-col>
                          </b-row> -->
                          <div v-if="question.note" class="note-question">
                            <small>{{ question.note }}</small>
                          </div>
                          <b-form-radio-group v-if="question.type == 'R'" v-model="question.value" :disabled="disabledModalField"
                                              :options="question.options" disabled-field="notEnabled" text-field="text"
                                              value-field="id"></b-form-radio-group>
                          <b-form-input v-else-if="question.type == 'T'" v-model="question.value" :disabled="disabledModalField"
                                        size="sm"/>
                          <b-form-input v-else-if="question.type == 'N'" v-model="question.value" :disabled="disabledModalField" number
                                        size="sm" type="number"/>
                          <b-form-checkbox-group v-else-if="question.type == 'C'" v-model="question.value"
                                                 :disabled="disabledModalField" :options="question.options" disabled-field="notEnabled"
                                                 text-field="text"
                                                 value-field="id"></b-form-checkbox-group>
                          <b-form-select v-else-if="question.type == 'S'" v-model="question.value"
                                         :disabled="disabledModalField" :options="question.options"></b-form-select>
                          <div class="error-txt">
                            <small v-if="errors.length > 0">Bạn không được để trống trường này</small>
                          </div>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col v-if="question.type == 'R' && question.value == 1" cols="12">
                      <b-form-textarea v-model="question.subValue" :disabled="disabledModalField" rows="1"
                                       size="sm"></b-form-textarea>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-card>
            </template>
            <template v-if="callStatusSelected == 0">
              <b-card body-class="p-1" class="mb-1">
                <b-card-text>
                  <b-row>
                    <b-col cols="12">
                      <b-form-group label="Thời gian hẹn gọi lại">
                        <flat-pickr v-model="appointmentTime" :config="{
                            enableTime: true,
                            dateFormat: 'd-m-Y H:i',
                          }" :disabled="disabledModalField" class="form-control"/>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-card>
            </template>
            <div class="d-flex justify-content-end mb-2">
              <button class="btn btn-primary" type="button" @click="handleOk">
                OK
              </button>
            </div>

          </b-col>

        </b-row>

      </validation-observer>
    </b-modal>
  </div>
</template>
<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {required} from '@validations'
import vSelect from "vue-select";
import {VueGoodTable} from "vue-good-table";
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip,
  VBTooltip,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import "@core/scss/vue/libs/vue-good-table.scss";
import Select2 from "v-select2-component";
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import Vue from "vue";
import VueExcelXlsx from "vue-excel-xlsx";
import {$ctx} from "@themeConfig";
import SearchSelect from "../components/select/SearchSelect.vue";

Vue.use(VueExcelXlsx);

export default {
  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BTabs,
    BTab,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BFormTextarea,
    BCardText,
    BInputGroup,
    flatPickr,
    SearchSelect
  },

  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  async mounted() {
    await this.getOutBound();
    await this.getTabTableData();
    this.fetchCities();
  },
  computed: {
    flowId() {
      return this.selectedTab;
    },
    disabledModalField() {
      return (
          this.selectedRecord &&
          (this.selectedRecord.Status === 2 || this.selectedRecord.Status === 3)
      );
    },
    exportExcelData() {
      let data = this.exportTableData || [];

      return data.map((el) => {
        return {
          ...el,
          Status: (this.status.find((o) => o.id == el.Status) || {text: ""})
              .text,
        };
      });
    },
  },
  watch: {
    callStatusSelected(newValue, oldValue) {
      // if(newValue == 0){
      //   this.appointmentTime = moment(new Date(), "DD-MM-YYYY HH:mm").add(1, 'days').format("DD-MM-YYYY HH:mm");
      // }
    },
  },
  methods: {
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      if (this.serverParams.columnFilters.Status == "") {
        delete this.serverParams.columnFilters.Status;
      }
    },
    async handleOk(bvModalEvt) {
      if (bvModalEvt) {
        bvModalEvt.preventDefault();
      }

      if (this.selectedRecord.Status === 2) {
        this.$bvModal.hide("activated-order-modal");
        return;
      }

      var validate = await this.$refs.modalView.validate().then((success) => {
        return success;
      });
      if (!validate) {
        this.$toast.warning("Vui lòng nhập các trường thông tin bắt buộc", {
          icon: true,
          closeButton: "button",
        });
        return;
      }

      this.callStatusSelected =
          this.listOfConnection.length > 0
              ? this.listOfConnection[this.listOfConnection.length - 1]
                  .callStatusSelected
              : 0;

      let data = {
        obid: this.selectedRecord.ID,
        // "appointmentTime": "",
        callStatus: this.callStatusSelected,
        note: this.detailQuestionExtra.Note
        // "results": {}
      };
      if (this.flowId == 6) {
        data.type = 2;
      }
      if (this.flowId === 11) {
        data.contactPhone = this.contactPhone ? this.contactPhone : null;
      }
      if (this.callStatusSelected == 0) {
        data.appointmentTime = this.appointmentTime;
      } else {
        data.results = {};
        this.detailQuestions.forEach((el) => {
          data.results[el.id] = el.value;
        });
      }
      useJwt
          .post("ob/submit", data)
          .then(async (response) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Cập nhật thành công!",
                icon: "CheckSquareIcon",
                variant: "success",
              },
            });
            await this.getTabTableData();
            if (this.flowId == 6) {
              this.$bvModal.hide("update-info-order-modal");
            } else {
              this.$bvModal.hide("activated-order-modal");
            }
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Lỗi cập nhật [" + error.response.data.result + "]!",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          });
    },
    // onSelectOrderType(val) {
    //   if (this.selectedTab != val) {
    //     this.selectedTab = val;
    //   }
    // },
    onSelectOrderTime(val) {
      if (this.selectedOrderTime != val) {
        this.selectedOrderTime = val;
      }
    },
    async onPageChange(params) {
      this.serverParams.page = params.currentPage;
      this.serverParams.currentPage = params.currentPage;
      await this.getTabTableData(true);
    },
    onSortChange(params) {
      this.updateParams(params);
      this.getTabTableData(false);
    },
    onColumnFilter(params) {
      this.updateParams(params);
      this.getTabTableData(false);
    },
    async onPerPageChange(params) {
      if (this.serverParams.pageSize !== params.currentPerPage) {
        this.serverParams.page = 1;
        this.serverParams.pageSize = params.currentPerPage;
        await this.getTabTableData(true);
      } else {
        setTimeout(() => {
          this.isLoading = false;
        }, 300);
      }
    },
    onConfirm1() {
    },
    onFailure1() {
    },
    onConfirm2() {
    },
    onFailure2() {
    },
    async onShowDetailModal(row) {
      this.appointmentTime = null;
      this.contactPhone = null;
      this.selectedRecord = JSON.parse(JSON.stringify(row));
      await this.getDetailData(row.ID);
      if (this.flowId == 6) {
        this.$bvModal.show("update-info-order-modal");
      } else {
        this.$bvModal.show("activated-order-modal");
      }
    },
    async getOutBound() {
      const response = await useJwt.get("ob/meta");
      if (response.data.code == 200) {
        this.flow = [
          {ID: 0, GroupID: 1, Name: "Tất cả"},
          ...response.data.result.Flow,
        ];
        this.callStatus = response.data.result.CallStatus.reverse();
        this.group = response.data.result.Group;
        this.questionType = response.data.result.QuestionType;
        this.status = response.data.result.Status;
      } else {
        this.flow = [{ID: 0, GroupID: 1, Name: "Tất cả"}];
        this.callStatus = [];
        this.group = [];
        this.questionType = [];
        this.status = [];
      }
    },
    getFieldsTable(columns) {
      this.fields = columns.map((c) => {
        const key = Object.keys(c)[0];
        if (key === "Status") {
          return {
            field: key,
            filterOptions: {
              enabled: true,
              placeholder: "",
              filterDropdownItems: this.status.map((el) => {
                return {...el, value: el.id};
              }),
            },
            label: c[key],
            required: true,
            disabled: true,
            tdClass: "text-center",
          };
        } else {
          return {
            field: key,
            filterOptions: {enabled: true, placeholder: ""},
            label: c[key],
            required: true,
            disabled: true,
            tdClass: "text-center",
            width:
                key === "ID"
                    ? "50px"
                    : key === "ContactNumber"
                        ? "100px"
                        : key === "CallTimes"
                            ? "70px"
                            : "auto",
          };
        }
      });

      this.fields.push({
        field: "action",
        filterOptions: {enabled: false, placeholder: ""},
        label: "Action",
        required: true,
        disabled: true,
        width: "100px",
      });
    },
    async getTabTableData(isGetColumn = true) {
      const response = await useJwt.post(
          `ob/tasks/${this.groupId}/${this.flowId}`,
          this.serverParams
      );
      if (response.data.code == 200) {
        this.tableData = response.data.result ? response.data.result : [];
        this.totalRecords = response.data.totalRecords;
        if (isGetColumn) {
          this.getFieldsTable(response.data.extra.Column);
        }
      } else {
        if (isGetColumn) {
          this.getFieldsTable(response.data.extra.Column);
        }
        this.tableData = [];
        this.totalRecords = 0;
      }

      useJwt
          .post(`ob/tasks/${this.groupId}/${this.flowId}`, this.serverParams)
          .then((rs) => {
            if (rs.data.code == 200) {
              this.exportTableData = rs.data.result ? rs.data.result : [];
            }
          });
    },
    async changeTab(e) {
      this.selectedTab = e.ID;
      this.groupId = e.GroupID;
      await this.getTabTableData();
      if (this.flowId == 6) {
        let self = this;
        this.startInterval = setInterval(async function () {
          console.log(' Interval =' + (new Date()));
          await self.getTabTableData();
        }, 40 * 1000);
      } else if (this.startInterval) {
        console.log(' clearInterval =' + (new Date()));
        clearInterval(this.startInterval);
        this.startInterval = null;
      }
    },
    getDateTime(e) {
      return moment(e).isValid() ? moment(e).format("DD/MM/YYYY HH:mm:ss") : "";
    },
    async getDetailData(id) {
      const response = await useJwt.get(`ob/detail/${id}`);
      if (response.data.code == 200) {

        const results = response.data.extra.Results || {};

        this.detailQuestions = response.data.result.map((el) => {
          return {
            ...el,
            value:
                this.selectedRecord.Status === 2 ||
                this.selectedRecord.Status === 3
                    ? results[el.id]
                    : null,
          };
        });
        this.detailQuestionExtra = response.data.extra;
        this.detailColumnExtra = response.data.extra.DetailColumn.map((el) => {
          let key = Object.keys(el)[0];
          let label = el[key];
          return {key, label};
        });

        if (response.data.extra.count.length > 0) {
          this.listOfConnection = response.data.extra.count.map((c) => {
            return {
              number: c.number,
              callStatus: this.callStatus,
              callStatusSelected: c.Status,
              disabledModalField: c.Status == 1 ? true : false,
            };
          });
        } else {
          this.listOfConnection = [
            {
              number: 0,
              callStatus: this.callStatus,
              callStatusSelected: 0,
              disabledModalField: false,
            },
          ];
        }

        if (this.flowId === 11) {
          this.listOfConnection.forEach((el) => {
            if (el.callStatus.filter((e) => e.id === 2).length !== 0) return
            el.callStatus.push({id: 2, text: 'Gửi tin ZNS'});
          })
        } else {
          this.listOfConnection.forEach((el) => {
            el.callStatus = el.callStatus.filter((e) => e.id != 2);
          })
        }


        this.callStatusSelected =
            this.listOfConnection.length > 0
                ? this.listOfConnection[this.listOfConnection.length - 1]
                    .callStatusSelected
                : 0;
        this.currentItem = this.detailQuestionExtra.Detail;
        if (response.data.extra.steps) {
          this.currentItem.steps = response.data.extra.steps.filter(
              (m) => m.LogType == "Order-Status"
          );
          this.currentItem.logs = response.data.extra.steps;
        }

        if (this.currentItem.CityId) {
          this.fetchDistricts(false, false);
          this.fetchWards(false, false);
          this.fetchHamlet(false, false);
        }
      } else {
        this.listOfConnection = [];
        this.detailQuestions = [];
        this.detailQuestionExtra = {};
        this.detailColumnExtra = [];
        this.currentItem = {};
      }
    },
    onCallStatusSelectedConnection: function (s) {
      this.callStatusSelected = s.callStatusSelected;
    },
    openTabCreateSimOrder: function () {
      window.open(`${$ctx.URL_FRONTEND}/mua-hang?iframe=true`, "_blank");
    },
    updatePhoneAndMail() {
      if (!this.isEditPhoneEmail) {
        this.isEditPhoneEmail = true;
        return;
      }

      this.loading(true);
      const data = {
        ContactPhone: this.currentItem.ContactPhone,
        Email: this.currentItem.Email,
        OrderId: this.currentItem.Id,
        Addr: this.currentItem.Addr,
        CityId: this.currentItem.CityId,
        DistrictId: this.currentItem.DistrictId,
        WardId: this.currentItem.WardId,
        HamletId: this.currentItem.HamletId,
        FlowId: this.flowId
      };
      useJwt
          .put("update-order-info/" + this.currentItem.OrderId, data)
          .then((response) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message,
                icon: "AlertTriangleIcon",
                variant: "info",
              },
            });
            this.isEditPhoneEmail = false;
            this.loading(false);
          })
          .catch((error) => {
            if (error.response.data.code == 403) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Không có quyền thao tác nghiệp vụ này!",
                  icon: "AlertTriangleIcon",
                  variant: "warning",
                },
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.response.data.result,
                  icon: "AlertTriangleIcon",
                  variant: "warning",
                },
              });
            }
            this.isEditPhoneEmail = false;
            this.loading(false);
          });
    },
    handleHide() {
      this.isEditPhoneEmail = false;
    },

    async fetchCities() {
      try {
        const res = await useJwt.post("getMasterData/GHTK_City", {
          columnFilters: {},
          sort: [],
          page: 1,
          pageSize: 1000,
        });

        this.Cities = res.data.result.map((item) => {
          return {
            value: item.Id,
            text: item.Name,
          };
        });
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Có lỗi trong quá trình lấy dữ liệu!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
      }
    },
    async fetchDistricts(isCityChange = false, showLoading = true) {
      if (isCityChange) {
        this.currentItem.DistrictId = 0;
        this.currentItem.WardId = 0;
      }

      if (this.currentItem.CityId > 0) {
        if (showLoading) {
          this.loading(true);
        }
        useJwt
            .post("getMasterData/GHTK_District", {
              columnFilters: {CityId: this.currentItem.CityId},
              sort: [],
              page: 1,
              pageSize: 1000,
            })
            .then((response) => {
              this.Districts = response.data.result.map((item) => {
                return {
                  value: item.Id,
                  text: item.Name,
                };
              });
              if (showLoading) {
                this.loading(false);
              }
            });
      }
    },
    async fetchWards(isDistrictChange = false, showLoading = true) {
      if (isDistrictChange) {
        this.currentItem.WardId = 0;
      }

      if (this.currentItem.DistrictId > 0) {
        if (showLoading) {
          this.loading(true);
        }

        useJwt
            .post("getMasterData/GHTK_Ward", {
              columnFilters: {DistrictId: this.currentItem.DistrictId},
              sort: [],
              page: 1,
              pageSize: 1000,
              lang: this.$l,
            })
            .then((response) => {
              this.Wards = response.data.result.map((item) => {
                return {
                  value: item.Id,
                  text: item.Name,
                };
              });
              if (showLoading) {
                this.loading(false);
              }
            });
      }
    },
    async fetchHamlet(isDistrictChange = false, showLoading = true) {
      this.hamlets = [];
      if (isDistrictChange) {
        this.hamlets.push({value: 0, text: "Khác"});
        this.currentItem.HamletId = 0;
      }

      if (this.currentItem.WardId >= 0) {
        if (showLoading) {
          this.loading(true);
        }

        useJwt
            .post("getMasterData/GHTK_Hamlet", {
              columnFilters: {WardId: this.currentItem.WardId},
              sort: [],
              page: 1,
              pageSize: 1000,
              lang: this.$l,
            })
            .then((response) => {
              for (let i in response.data.result) {
                this.hamlets.push({
                  value: response.data.result[i].Id,
                  text: response.data.result[i].Name,
                })
              }
              this.hamlets.push({value: 0, text: "Khác"});
              if (showLoading) {
                this.loading(false);
              }
            });
      }
    },
    async cancelOrder() {
      useJwt
          .put("cancel-order/" + this.currentItem.OrderId, {})
          .then((response) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message,
                icon: "AlertTriangleIcon",
                variant: "info",
              },
            });
            this.isEditPhoneEmail = false;
            this.loading(false);
          })
          .catch((error) => {
            if (error.response.data.code == 403) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Không có quyền thao tác nghiệp vụ này!",
                  icon: "AlertTriangleIcon",
                  variant: "warning",
                },
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.response.data.result,
                  icon: "AlertTriangleIcon",
                  variant: "warning",
                },
              });
            }
            this.loading(false);
          });
    }
  },
  data() {
    return {
      required,
      appointmentTime: null,
      callStatusSelected: 0,
      detailColumnExtra: [],
      selectedTab: 1,
      selectedOrderTime: 0,
      serverParams: {
        columnFilters: {},
        sort: [],
        page: 1,
        pageSize: 50,
      },
      totalRecords: 0,
      isLoading: false,
      flow: [],
      callStatus: [],
      group: [],
      groupId: 0,
      questionType: [],
      status: [],
      tableData: [],
      exportTableData: [],
      selectedRecord: null,
      detailQuestions: [],
      detailQuestionExtra: {},
      contactPhone: null,
      fields: [
        {
          field: "action",
          filterOptions: {enabled: false, placeholder: ""},
          label: "Action",
          required: true,
          disabled: true,
          width: "100px",
        },
      ],
      listOfConnection: [],
      currentItem: {},
      isEditPhoneEmail: false,
      Cities: [],
      Districts: [],
      Wards: [],
      hamlets: [],
      startInterval: ''
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.deliverd .nav-link {
  padding: 0.61rem 0.9rem !important;
}

.modal-activated-order {
  height: 700px;
  color: #000000;
}

.col-700-scroll {
  height: 680px;
  overflow: auto;
}
</style>
<style scoped>
.error-txt small {
  color: red;
}

.unselected {
  background: rgb(175, 175, 175) !important;
  border: rgb(175, 175, 175) !important;
}

.text-end {
  text-align: end;
}

.action-col {
  width: 100%;
  display: flex;
  justify-content: center;
}

.order-id:hover {
  cursor: pointer;
  font-weight: bold;
  color: rgb(34, 100, 243);
}

.detail-custom-table {
  width: 100%;
}

.detail-custom-table {
  display: inline-table;
  border: solid 1px rgb(207 207 207);
}

.detail-custom-table th,
.detail-custom-table td {
  border: solid 1px rgb(207 207 207);
  padding: 5px 10px;
}

.detail-custom-table th {
  vertical-align: baseline;
}

.history-call__header {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}

.history-call__header h5 {
  margin: 0;
}

.note-question {
  font-style: italic;
  color: rgb(233, 71, 22);
  margin-bottom: 9px;
}
</style>
